module.exports = __webpack_public_path__ + "img/Combos.fw.ea926324.png";